import React from 'react';
import { createBrowserRouter } from "react-router-dom";
import App from '../App';
import Records from '../Records';
import DataFileStatus from '../DataFileStatus';
import CurationStatus from '../CurationStatus';
import HistoryTab from '../HistoryTab';
import Login from '../Login';
import ProtectedRoute from './ProtectedRoute';  // Import the ProtectedRoute
import BasicFilterDemo from '../PrimeDatatable'
import PharmaTracker from '../PharmaTracker';
import RunValidation from '../RunValidation';
const Router = createBrowserRouter([
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        element: <Records />,
        children:[{
          path:":tabId",
          element:<Records />
        }]
      },
      {
        path: '/datafiles',
        element: <DataFileStatus />
      },
      {
        path: '/curation',
        element: <CurationStatus />
      },
      {
        path: '/table',
        element: <BasicFilterDemo/>
      },
      {
        path: '/history',
        element: <HistoryTab/>
      },
      {
        path: '/rx_trend',
        element: <PharmaTracker/>
      },
      {
        path: 'bi_data_audit',
        element: <RunValidation/>
      }

    ]
  },
  {
    path: '/login',
    element: <Login />
  }
]);

export default Router;
